import { useEffect, useState } from "react";
import { AdminOrganizationContextDetail } from "../../types/adminEntities";
import { useAdminOrganizationContextCache } from "./AdminOrganizationContextCache";

type UseAdminOrganizationContextResult = {
  organizationContext: AdminOrganizationContextDetail | null;
  isLoading: boolean;
};

export const useAdminOrganizationContext = (organizationId: null | string): UseAdminOrganizationContextResult => {
  const { contextsByOrganizationId, ensureOrganizationContext } = useAdminOrganizationContextCache();
  const [organizationContext, setOrganizationContext] = useState<AdminOrganizationContextDetail | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!organizationId) {
      setOrganizationContext(null);
      setIsLoading(false);
      return;
    }

    const cachedContext = contextsByOrganizationId[organizationId];
    if (cachedContext) {
      setOrganizationContext(cachedContext);
      setIsLoading(false);
      return;
    }

    let isCancelled = false;
    setIsLoading(true);
    void ensureOrganizationContext(organizationId).then((resolvedContext) => {
      if (!isCancelled) {
        setOrganizationContext(resolvedContext);
        setIsLoading(false);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [organizationId, contextsByOrganizationId, ensureOrganizationContext]);

  return { organizationContext, isLoading };
};
